<template>
  <div class="space-y-5">
    <RevSkeleton
      :aria-label="i18n(translations.skeletonsLabel)"
      class="mb-12"
      height="20px"
      shape="rectangle"
      width="80px"
    />
    <Title>{{ i18n(actionsListTranslations.title) }}</Title>

    <div class="flex space-x-8 pt-20">
      <RevSkeleton
        :aria-label="i18n(translations.skeletonsLabel)"
        height="32px"
        shape="rectangle"
        width="64px"
      />
      <RevSkeleton
        :aria-label="i18n(translations.skeletonsLabel)"
        height="32px"
        shape="rectangle"
        width="64px"
      />
      <RevSkeleton
        :aria-label="i18n(translations.skeletonsLabel)"
        height="32px"
        shape="rectangle"
        width="64px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkeleton } from '@ds/components/Skeleton'

import actionsListTranslations from '../ActionsList/ActionsList.translations'
import Title from '../Title/Title.vue'

import translations from './Loading.translations'

const i18n = useI18n()
</script>
